/**
 * App Header component terms
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const appHeader = {
	component: {
		label: "component:appHeader#label",
		description: "component:appHeader#description"
	}
};
